module.exports = __webpack_public_path__ + "img/matrix_item.d71754a3.png";